export default __webpack_public_path__ + "static/media/Mediacorp SG.5a6d810b.jpg";